import React from 'react';
import ReactDOM from 'react-dom';

import Iconset from '../icons';

class NoteIntro extends React.Component{

	render(){
		return (<div className="note-intro">
			<div className="note-intro-inner">
				<div className="logo-icon">
					<Iconset.logo />
				</div>
				<h1>#{this.props.index + 1} {this.props.headline}</h1>
				<h2>Blossom Track by Track</h2>
			</div>
		</div>);
	}
}

export default NoteIntro;


// WEBPACK FOOTER //
// ./src/scripts/chapter3/playlist_song_intro.js